import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventManagerService } from '../../service/event-manager.service';

@Component({
  selector: 'app-button-copy',
  templateUrl: './button-copy.component.html',
  styleUrls: ['./button-copy.component.scss']
})
export class ButtonCopyComponent implements OnInit, OnDestroy {
  @Input() value: string;
  @Input() isDisplay: boolean = false;
  subscriptions: Subscription[];
  contentClipboard: string;
  isCopied: boolean = false;
  constructor(
    public eventManager: EventManagerService
  ) {

  }

  ngOnInit() {
    this.subscriptions = [...[
      this.eventManager.subscribe(('get-content-clipboard'), (res) => {
        this.contentClipboard  = res.content.value;
      }),
    ]];
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getDataClipboard() {
    navigator.clipboard.readText()
    .then(text => {
      this.eventManager.broadcast({
        name: 'copy-clipboard',
        content: {
          value: text
        }
      })
    });
  }
}
